


























































































































































































































































































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import OverlayWindow from "../general/OverlayWindow.vue";
import Loading from "../general/Loading.vue";

import GroupBookingProgramJson from "../../shared/GroupBookingProgramJson";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import PriceTemplateManualJson, { PriceTemplateManual } from "../../shared/PriceTemplateManualJson";

import { validateGroupBookingProgramJsonManagement } from "../../shared/GroupBookingProgramJson";
import { validateGroupBookingProgramJsonManagementAdd } from "../../shared/GroupBookingProgramJson";
import { ValidationResult, Validation } from "../../shared/Validation";

import PriceTemplates from "../custom/PriceTemplates";

type keysForCachedPrices = {
  [key in keyof Pick<
    GroupBookingProgramJson,
    "basePriceHalfDay" | "basePriceFullDay" | "extraParticipantPrice" | "cancellationFee"
  >]: string;
};

export default Vue.extend({
  name: "GroupsProgramDetails",
  components: {
    OverlayWindow,
    Loading,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    programId: Number,
    selectedProgramDetails: Object,
    mode: String,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      editable: false as boolean,
      detailsTitle: "",
      UserPermissionRank: UserPermissionRank,
      PriceTemplates: PriceTemplates as PriceTemplateManual,
      detailsMode: "",
      programDetails: null as GroupBookingProgramJson | null,
      cachedPrices: {
        basePriceFullDay: "0,00",
        basePriceHalfDay: "0,00",
        extraParticipantPrice: "0,00",
        cancellationFee: "0,00",
      } as keysForCachedPrices,
      hasChanges: false,
      hintChanged: {
        program: false as boolean,
        staff: false as boolean,
        restrictStaff: false as boolean,
        estimatedChildrenCount: false as boolean,
      },
      toValidate: {} as any,
      validation: null as ValidationResult<GroupBookingProgramJson> | null,
      submitValidation: false as boolean,
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.initProgramDetails();
  },
  mounted() {},
  methods: {
    initProgramDetails() {
      this.loadProgramDetails();

      this.selectDetailsMode(this.mode);
    },

    setCachedData() {
      this.setCachedPrices();
    },

    async loadProgramDetails() {
      if (this.programId != null) {
        this.programDetails = this.selectedProgramDetails;
      } else {
        let cancellationRemarks = "";

        if (this.PriceTemplates.hasOwnProperty("workshopPrices")) {
          cancellationRemarks = (this.PriceTemplates.holidaysPrices.default as PriceTemplateManualJson)
            .cancellationRemarks;
        }

        this.programDetails = {
          ID: null,
          title: "",
          description: "",
          basePriceHalfDay: 0,
          basePriceFullDay: 0,
          basePriceParticipantCount: 1,
          extraParticipantPrice: 0,
          cancellationFee: 0,
          cancellationRemarks,
        };
      }

      this.setCachedData();
      this.hasChanges = false;
    },

    //START set cached prices

    setCachedPrices() {
      if (this.programDetails != null) {
        let k = this.cachedPrices;
        let i: keyof typeof k;

        for (i in this.cachedPrices) {
          let price = this.programDetails[i]
            .toString()
            .padStart(3, "0")
            .replace(/(\d{2,2})$/g, ",$1")
            .replace("NaN", "");

          this.cachedPrices[i] = price;
        }
      }
    },

    //END set cached data

    //START set input data (where data be cached)

    formatAndSetCachedPrices(key: keyof keysForCachedPrices) {
      if (this.programDetails != null) {
        let price = this.cachedPrices[key].replace(".", ",");

        if (!price.includes(",")) {
          price += ",00";
        }

        if (!price.match(/^\d{1,}(,\d{2})?$/)) {
          price = "";
        }

        this.cachedPrices[key] = price;
        this.programDetails[key] = parseInt(price.replace(/[\D]/g, ""));
      }
    },

    //END set input data

    selectDetailsMode(mode: string) {
      this.resetHintChanged();

      switch (mode) {
        case "add":
          this.detailsMode = "add";
          this.detailsTitle = "Gruppenvorlage hinzufügen";
          this.editable = true;
          break;

        case "edit":
          this.detailsMode = "edit";
          this.detailsTitle = "Gruppenvorlage bearbeiten";
          this.editable = true;
          break;

        default:
          this.detailsMode = "read";
          this.detailsTitle = "Gruppenvorlage";
          this.editable = false;
          break;
      }
    },

    toggleEditMode() {
      this.editable = !this.editable;
    },

    resetHintChanged() {
      let k = this.hintChanged;
      let i: keyof typeof k;

      for (i in this.hintChanged) {
        this.hintChanged[i] = false;
      }
    },

    stopEditMode() {
      if (!this.hasChanges) {
        //todo: use $refs
        document.getElementsByClassName("overlay-window-scroll")[0].scrollTo(0, 0);
        this.selectDetailsMode("show");
        this.hasChanges = false;
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          document.getElementsByClassName("overlay-window-scroll")[0].scrollTo(0, 0);
          this.selectDetailsMode("show");
        } else {
          //do nothing
        }
      }
    },

    closeDetails() {
      if (!this.hasChanges) {
        this.$emit("closeOverlay");
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          this.$emit("closeOverlay");
        } else {
          //do nothing
        }
      }
    },

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.programDetails != null) {
        this.validation = validateGroupBookingProgramJsonManagement(this.programDetails);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    async addNewProgram() {
      if (this.programDetails != null) {
        this.loadingGeneral = true;

        this.validation = validateGroupBookingProgramJsonManagementAdd(this.programDetails);

        this.submitValidation = true;

        if (this.validation != null && this.validation.isValid == true) {
          try {
            this.programDetails = await this.restClient.addGroupBookingProgram(this.programDetails);
            alert("Das Gruppen Angebot wurde erfolgreich hinzugefügt.");
            this.$nextTick(() => {
              this.hasChanges = false;
              this.loadingGeneral = false;
              this.stopEditMode();
            });
          } catch (e) {
            this.loadingGeneral = false;
            alert(e.message);
          }
        } else {
          this.loadingGeneral = false;
          //todo Validation Error anzeigen
          alert("Das Gruppen Angebot konnte nicht hinzugefügt werden. Bitte überprüfen Sie Ihre Angaben.");
        }
      }
    },

    async saveProgramDetails() {
      if (this.programDetails != null) {
        if (this.hasChanges) {
          this.loadingGeneral = true;

          //todo ###START
          //todo: Validation muss durchgeführt werden (siehe hier) ->AUCH bei SettingsDetails
          this.validation = validateGroupBookingProgramJsonManagement(this.programDetails);
          //todo ###END
          if (this.validation != null && this.validation.isValid == true) {
            if (this.restClient != null) {
              try {
                let updatedProgramDetails = await this.restClient.updateGroupBookingProgram(this.programDetails);

                this.hasChanges = false;
                this.loadingGeneral = false;
                this.stopEditMode();

                //TODO: Validation error loest alert auch aus -> prüfen
                alert("Die Änderungen wurden erfolgreich gespeichert.");
              } catch (e) {
                this.loadingGeneral = false;
                alert(e.message);
              }
            }
          } else {
            this.loadingGeneral = false;
            alert("Die Änderungen konnten nicht gespeichert werden. Bitte überprüfen Sie Ihre Änderungen.");
          }
        } else {
          alert("Es wurden keine Änderungen vorgenommen.");
        }
      }
    },

    async deleteProgram() {
      if (this.programId != null) {
        let c = confirm("Wollen Sie dieses Angebot wirklich unwiderruflich löschen?");
        if (c == true) {
          if (this.restClient != null) {
            try {
              await this.restClient.deleteGroupBookingProgram(this.programId);
              this.closeDetails();
              alert("Das Gruppen Angebot wurde erfolgreich gelöscht.");
            } catch (e) {
              alert(e.message);
            }
          }
        } else {
          //do nothing
        }
      }
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },

  watch: {
    programDetails: {
      handler(val, oldVal) {
        if (oldVal != null) {
          this.hasChanges = true;
        }
      },
      deep: true,
    },
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    parseBasePriceParticipantCount: {
      get(): number | undefined {
        if (this.programDetails != null) {
          return this.programDetails.basePriceParticipantCount;
        }
      },
      set(value: string) {
        if (this.programDetails != null) {
          this.programDetails.basePriceParticipantCount = parseInt(value);
        }
      },
    },
  },
});
